import createStore from "../utils/create-store";

interface IOMissingEntitiesStore {
    missingEntities: string[];
    missingEntityDetails: Record<string, any>;
    setMissingEntityDetails: (data: Record<string, any>) => void;
}

export const useMissingEntitiesStore = createStore<IOMissingEntitiesStore>((set) => ({
    missingEntities: [],
    missingEntityDetails: {},
    setMissingEntityDetails: (data) =>
        set((state) => {
            state.missingEntities = [...Object.keys(data)];
            state.missingEntityDetails = { ...data };
        }),
}));
